// @ts-nocheck
/* Port of views/dashboard/module/VoiceLibraryAclModal.js — byte-identical. */
import React, { useEffect, useState } from 'react';
import { AclSettingsModal, AclModalSection, FaPhoneAlt, FaGlobe } from '@/features/acl-settings/aclSettingsUi';

const VoiceLibraryAclModal = ({
  show,
  onHide,
  initialValues = {},
  onSave,
  voiceTypeOptions = [],
  languageOptions = [],
  limitedByParent = false,
}) => {
  const [voiceTypes, setVoiceTypes] = useState([]);
  const [languages, setLanguages] = useState([]);

  const typeValues = voiceTypeOptions.map((o) => o.value);
  const languageValues = languageOptions.map((o) => o.value);

  useEffect(() => {
    if (show) {
      const fromTypes = normalizeVoiceTypes(initialValues.voice_types).filter((v) => typeValues.includes(v));
      const fromLanguages = normalizeList(initialValues.languages).filter((v) => languageValues.includes(v));
      setVoiceTypes(fromTypes.length > 0 ? fromTypes : [...typeValues]);
      setLanguages(fromLanguages.length > 0 ? fromLanguages : [...languageValues]);
    }
  }, [show, initialValues, voiceTypeOptions, languageOptions]);

  const toggle = (list, setList, value) => {
    setList((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const handleReset = () => {
    setVoiceTypes([]);
    setLanguages([]);
  };

  const handleSave = () => {
    onSave({ voice_types: voiceTypes, languages });
    onHide();
  };

  const canSave = voiceTypes.length > 0 && languages.length > 0;

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Voice Library — Upload Options"
      icon={FaPhoneAlt}
      description="Select voice types and languages users with this ACL can use when uploading voice files."
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={!canSave}
    >
      <AclModalSection icon={FaPhoneAlt} title="Voice Type" subtitle="Choose the type(s) of voice files.">
        {voiceTypeOptions.length === 0 ? (
          <p className="acl-modal-empty">No voice types available to grant.</p>
        ) : (
          <div className="d-flex flex-wrap gap-3">
            {voiceTypeOptions.map((opt) => (
              <div key={opt.value} className="form-check acl-modal-check">
                <input
                  type="checkbox"
                  id={`vl-type-${opt.value}`}
                  className="form-check-input"
                  checked={voiceTypes.includes(opt.value)}
                  onChange={() => toggle(voiceTypes, setVoiceTypes, opt.value)}
                />
                <label htmlFor={`vl-type-${opt.value}`} className="form-check-label">
                  {opt.label}
                </label>
              </div>
            ))}
          </div>
        )}
      </AclModalSection>

      <AclModalSection icon={FaGlobe} title="Language" subtitle="Select the languages users can use.">
        {languageOptions.length === 0 ? (
          <p className="acl-modal-empty">No languages available to grant.</p>
        ) : (
          <div className="row g-2">
            {languageOptions.map((opt) => (
              <div key={opt.value} className="col-md-6">
                <div className="form-check acl-modal-check">
                  <input
                    type="checkbox"
                    id={`vl-lang-${opt.value}`}
                    className="form-check-input"
                    checked={languages.includes(opt.value)}
                    onChange={() => toggle(languages, setLanguages, opt.value)}
                  />
                  <label htmlFor={`vl-lang-${opt.value}`} className="form-check-label">
                    {opt.label}
                  </label>
                </div>
              </div>
            ))}
          </div>
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

function normalizeVoiceTypes(types) {
  if (!Array.isArray(types)) return [];
  return types.map((t) => String(t).trim().toLowerCase());
}

function normalizeList(values) {
  if (!Array.isArray(values)) return [];
  return values.map((v) => String(v).trim());
}

export default VoiceLibraryAclModal;
